import { render, staticRenderFns } from "./App-WEB.vue?vue&type=template&id=12ce08e8"
var script = {}
import style0 from "./App-WEB.vue?vue&type=style&index=0&id=12ce08e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports